import { companySchema } from "@/schema/Company";
import { companyUserSchema } from "@/schema/CompanyUser";
import { z } from "zod";

export const companyProfileSchema = companySchema.extend({
  company_users: z.array(companyUserSchema),
});

export type CompanyProfile = z.infer<typeof companyProfileSchema>;
